/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISurveyOptionGroup } from 'app/shared/model/survey-option-group.model';

export interface ISurveyOptionChoice {
  id?: string;
  optionChoiceName?: string;
  sortOrder?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  surveyOptionGroup?: ISurveyOptionGroup;
}

export const defaultValue: Readonly<ISurveyOptionChoice> = {
  active: false,
};
